import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { fetchUserPets } from "../../features/userNotifications/notificationSlice";
import HomeSearcher from "../home/HomeSearcher";
import "../../index.css";
import ToolTips from "../ToolTips";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";

const Navbar = ({ isMenuOpen, setIsMenuOpen }) => {
  const dispatch = useDispatch();
  const auth = getAuth();
  const currentUser = auth.currentUser;
  const location = useLocation();
  const [loggedIn, setLoggedIn] = useState(false);
  const [userPhoto, setUserPhoto] = useState(null);
  const [showSearcher, setShowSearcher] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1066);

  const notificationsCount = useSelector(
    (state) => state.notification.notifications,
    shallowEqual
  );
  const [notif, setNotif] = useState(notificationsCount);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowSearcher(scrollPosition > 500);
    };

    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1066);
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const categoryButtons = [
    {
      to: "/buscador/encontrado",
      icon: "/img/Perdido.svg",
      label: "Perdí mi amigo",
      alt: "Perdido",
    },
    {
      to: "/buscador/buscando",
      icon: "/img/Encontrado.svg",
      label: "Encontré un amigo",
      alt: "Encontrado",
    },
    {
      to: "/buscador/adopcion",
      icon: "/img/Adoptar.svg",
      label: "Adoptar un amigo",
      alt: "Adoptar",
    },
    {
      to: "/compartir?estado=4",
      icon: "/img/Adopcion.svg",
      label: "Poner en adopción",
      alt: "Adopción",
    },
  ];

  useEffect(() => {
    if (currentUser) {
      dispatch(fetchUserPets());
      setNotif(notificationsCount);
    }
  }, [currentUser, dispatch, notificationsCount]);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setLoggedIn(true);
        setUserPhoto(user.photoURL);
      } else {
        setLoggedIn(false);
        setUserPhoto(null);
      }
    });

    return () => unsubscribe();
  }, []);

  return location.pathname !== "/sign-in" ? (
    <main className="relative w-full">
      <nav
        className={`${
      location.pathname === "/" ? "fixed" : "sticky"
    } top-0 left-0 w-full ${
      isMenuOpen ? "z-50" : "z-50"
    } font-main transition-all duration-300 ease-out overflow-hidden ${
      location.pathname === "/" && showSearcher && isLargeScreen ? "h-40" : "h-16"
    } py-2 ${
      location.pathname === "/" ||
      location.pathname === "/preguntas-frecuentes" ||
      location.pathname === "/quienes-somos"
        ? "bg-secondary"
        : "bg-transparent"
    }`}
  >
        <div className="px-[15dvw]  sm:px-[8dvw] relative">
          <div className="flex items-center w-full justify-between">
            {/* Logo */}
            <div className="flex items-center">
              <Link
                className="flex"
                to="/"
                onClick={(e) => {
                  if (location.pathname === "/") {
                    e.preventDefault();
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }
                }}
              >
                <img src="/catw.webp" alt="Logo" className="w-12 h-12 mr-2" />
                
  <p
    className="text-md pt-5 font-main font-medium text-transparent bg-clip-text whitespace-nowrap sm:hidden"
    style={{
      backgroundColor: "white",
      backgroundSize: "cover",
    }}
  >
    BuscaTuAmigo
  </p>
              </Link>
            </div>

            {/* Perfil + Hamburguesa en el mismo div, alineados a la derecha */}
            <div className="flex items-center gap-2 relative z-10">
              {/* Perfil */}
              {loggedIn ? (
                <div className="relative">
                  {userPhoto && location.pathname !== "/perfil" && (
                    <ToolTips
                      text="Tu perfil, mascotas publicadas y notificaciones"
                      position="bottom"
                    >
                      <Link to="/perfil" className="relative">
                        <img
                          src={userPhoto}
                          alt="Profile"
                          className="w-10 h-10 rounded-full"
                        />
                        {notif > 0 && (
                          <p className="font-main absolute -bottom-1 -right-1 w-4 h-4 bg-[#cf2f2f] text-center text-white text-[x-small] rounded-full flex items-center justify-center">
                            {notif}
                          </p>
                        )}
                      </Link>
                    </ToolTips>
                  )}
                </div>
              ) : (
                <Link
                  to="/perfil"
                  className="bg-secondary hover:bg-orange-600 font-main text-regular sm:text-xs bg-opacity-75 text-white py-2 px-4 sm:px-2 rounded relative"
                >
                  Iniciar sesión
                </Link>
              )}

              {/* Botón hamburguesa debajo de 1066px y solo en la Home */}
              {location.pathname === "/" && (
                <button
                  className="nav:hidden flex items-center justify-center p-2 text-white ml-2 hover:rounded-md hover:bg-white hover:bg-opacity-20 transition-all duration-200"
                  onClick={() => setIsMenuOpen(true)}
                >
                  <FontAwesomeIcon icon={faBars} className="text-3xl"/>
                </button>
              )}
            </div>
          </div>

          {/* Menú hamburguesa modal/drawer debajo de 1066px y solo en la Home */}
          {location.pathname === "/" && isMenuOpen && (
            <div className="nav:hidden gap-2 fixed inset-0 bg-black bg-opacity-50 z-[99]">
              <div className="fixed top-0 right-0 h-full bg-white shadow-lg p-4 overflow-y-auto max-h-screen flex flex-col gap-4 z-[100]">
                <button
                  className="self-end flex items-center rounded-md hover:bg-black hover:bg-opacity-20 hover:text-red-800 text-secondary z-[101]"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <FontAwesomeIcon icon={faXmark} className="w-9 h-9" />
                </button>
                {categoryButtons.map((button, index) => (
                  <Link
                    key={index}
                    to={button.to}
                    className="flex items-center gap-5 p-5 rounded hover:bg-secondary hover:text-white transition"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <img src={button.icon} alt={button.alt} className="w-16 h-16" />
                    <span className="font-main font-semibold text-xl">{button.label}</span>
                  </Link>
                ))}
              </div>
            </div>
          )}

          {/* HomeSearcher solo en 1066px y mayores */}
          <div
            className={`absolute left-1/2 top-2 transform -translate-x-1/2 min-w-[41dvw] transition-opacity duration-300 nav:block hidden ${
              showSearcher && location.pathname === "/" ? "opacity-100" : "opacity-0 pointer-events-none"
            }`}
          >
            <HomeSearcher isCompact={true} />
          </div>

          {/* Menú de categorías solo en 1066px y mayores */}
          <div
            className={`pt-2 transition-opacity duration-300 nav:block hidden ${
              showSearcher && location.pathname === "/"
                ? "opacity-100"
                : "opacity-0 pointer-events-none"
            }`}
          >
            <div className="flex justify-center items-center gap-20">
              {categoryButtons.map((button, index) => (
                <Link
                  key={index}
                  to={button.to}
                  className="flex flex-col items-center rounded-md justify-center p-2 hover:bg-white hover:bg-opacity-20 transition-all duration-200 transform hover:scale-125"
                >
                  <img
                    src={button.icon}
                    alt={button.alt}
                    className="w-14 h-14 mb-1 filter brightness-0 invert"
                  />
                  <span className="text-xs font-main text-white text-center">
                    {button.label}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </nav>
    </main>
  ) : null;
};

export default Navbar;